import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

const ProfileDashboardStep = ({
    description,
    linkURL,
    linkText,
    title
}) => {

    return (
        <div className="col-12 col-lg-6 mybswh-profile-step">
            <div className="mybswh-profile-step--text">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
            <div className="mybswh-profile-step--link">
                <Link to={{ pathname: `${linkURL}` }}>{linkText}</Link>
            </div>
        </div>
    );
}

ProfileDashboardStep.defaultProps = {
    description: "",
    linkURL: "",
    linkText: "",
    title: "",
};

ProfileDashboardStep.propTypes = {
    description: PropTypes.string,
    linkURL: PropTypes.string,
    linkText: PropTypes.string,
    title: PropTypes.string
};

export default ProfileDashboardStep;